import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { SelectedProductProvider } from './contexts/SelectedProductContext';

import DiwasaRouter from './components/Diwasa-Router';
import Product2Router from './components/Product2Router';
import Product3Router from './components/Product3Router';
import Product4Router from './components/Product4Router';
import Header from './components/Header';
import Home from './components/Home';
import About from './components/About';
import TestDashboard from './components/TestDashboard';

function AppContent() {
  const location = useLocation();
  const excludedPaths = ["/product1", "/product2", "/product3", "/product4"];

  // Check if the current path starts with any of the excluded paths
  const shouldShowHeader = !excludedPaths.some(path => location.pathname.startsWith(path));

  return (
    <>
      {shouldShowHeader && <Header />} {/* Show Header if not in excluded paths */}

      <Routes>
        {/* General Routes */}
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/test" element={<TestDashboard />} />
        <Route path="/" element={<Home />} /> {/* Default Home Route */}

        {/* Product Routes with Nested Routing */}
        <Route path="/product1/*" element={<DiwasaRouter />} />
        <Route path="/product2/*" element={<Product4Router />} />
        <Route path="/product3/*" element={<Product3Router />} />
        <Route path="/product4/*" element={<Product2Router />} />

        {/* Redirect to Selected Product */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );

}

function App() {
  return (
    <SelectedProductProvider>
      <AppContent />
    </SelectedProductProvider>
  );
}

export default App;
